import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0% {
    r: 1;
    stroke-opacity: 1;
  }
  100% {
    r: 20;
    stroke-opacity: 0;
  }
`;

const LoaderSvg = styled.svg`
  overflow: visible;

  .ring {
    fill: none;
    stroke: ${({ theme }) => theme.palette.primary.shade5};
    stroke-width: 3;
    transform-origin: 50% 50%;
    animation: ${pulse} 1.8s cubic-bezier(0.165, 0.84, 0.44, 1) infinite;
  }

  .ring1 {
    animation-delay: 0s;
  }

  .ring2 {
    animation-delay: -0.9s;
  }
`;

const Loader = () => {
  return (
    <LoaderSvg id="loader" width="30" height="30" viewBox="0 0 44 44" xmlns="http://www.w3.org/2000/svg">
      <circle className="ring ring1" cx="22" cy="22" r="1" />
      <circle className="ring ring2" cx="22" cy="22" r="1" />
    </LoaderSvg>
  );
};
export default Loader;
